import React, { useEffect, useState } from "react";
import BaseDrawer from "../BaseDrawer";
import AboutMenu from "./AboutMenu/AboutMenu";
import MainMenu from "./MainMenu/MainMenu";
import BackgroundMenu from "./BackgroundMenu/BackgroundMenu";
const RightDrawer = (props) => {
  const [show, setShow] = useState(false);
  const [sectionName, setSectionName] = useState("Menu");
  useEffect(() => {
    props.show && setShow(true);
  }, [props.show]);

  const handleBackClick = () => {
    if (sectionName === "Về bảng này" || sectionName === "Thay đổi nền")
      setSectionName("Menu");
    else setSectionName("Thay đổi nền");
  };

  return (
    <BaseDrawer
      title={sectionName}
      show={show}
      closeCallback={(param) => {
        setShow(param);
        props.closeCallback();
      }}
      backClickCallback={handleBackClick}
      showBackIcon={sectionName !== "Menu"}
      content={
        sectionName === "Menu" ? (
          <MainMenu
            menuCallback={(param) => {
              setSectionName(param);
            }}
          />
        ) : sectionName === "Về bảng này" ? (
          <AboutMenu />
        ) : (
          <BackgroundMenu
            menuCallback={(param) => {
              setSectionName(param);
            }}
            sectionName={sectionName}
          />
        )
      }
    />
  );
};

export default RightDrawer;
